import React from 'react';
import ContractAddForm from '../../forms/ContractAddForm/ContractAddForm';
import '../ContractsPage/ContractsAddPage/ContractsAddPage.scss';

const ContractsAddPage = () => (
  <div className="ContractsAddPage" data-testid="ContractsAddPage">
    <ContractAddForm
      spidPage={true}/>
  </div>
);

ContractsAddPage.propTypes = {};

export default ContractsAddPage;